import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {ClassificationType} from "../../../models/classification-type";
import {IdValue} from "../../../models/id-value";
import {ServiceCopyProperties} from "../../../models/service-copy-properties";
import {ClassificationControllerService} from "../../../services/classifications-controller/classification-controller.service";
import { BaseError } from "../base-error";
import {ServiceCopyControllerService} from "../../../services/service-controller/service-copy-controller.service";

@Component({
  selector: "service-copy-modal",
  templateUrl: "./service-copy-modal.component.html",
})
export class ServiceCopyModalComponent extends BaseError implements OnChanges {
  @Output() public formSubmit = new EventEmitter();
  @Input() public serviceName: string;
  @Input() public serviceId: string;
  public serviceCopyProperties = new ServiceCopyProperties();
  public classifications: any[] = [];
  public classificationTypes: ClassificationType[];
  public classificationsFlatten: any[] = [];
  public allClassificationSelected: boolean;
  public selectedCatalogues: any[] = [];

  constructor(private classificationControllerService: ClassificationControllerService,
              private serviceCopyControllerService: ServiceCopyControllerService,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.loadClassificationTypes();
    this.srviceSelected();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.serviceName && changes.serviceName.currentValue) {
      this.serviceName = this.serviceName + " - copy - " + new Date().toLocaleString();
    }
  }

  public cancel() {
    this.formSubmit.emit({
      save: false, cancel: true,
    });
  }

  public copy() {
    this.serviceCopyProperties.newServiceName = this.serviceName;
    this.formSubmit.emit({
      save: true, properties: this.serviceCopyProperties,
    });
  }

  public determinantsSelected() {
    if (this.serviceCopyProperties.determinantsSelected) {
      this.serviceCopyProperties.catalogsSelected = true;
    }
  }

  public loadClassificationTypes() {
    this.serviceCopyControllerService.getServiceClassifications(this.serviceId).subscribe(
        (data) => this.buildDropDown(data),
        (error) => this.showErrorMessage(error),
    );
  }

  public buildDropDown(classifications: ClassificationType[]) {
    this.classificationsFlatten = [];
    this.classifications = [];
    for (const classification of classifications) {
        const idValue = new IdValue();
        idValue.id = classification.id;
        idValue.text = classification.name;
        this.classifications.push(idValue);
        this.classificationsFlatten.push(classification.id);
    }
    this.selectAllCatalogues();
  }

  public selectAllCatalogues(): void {
    if (!this.allClassificationSelected) {
      this.serviceCopyProperties.catalogsToCopy = this.classificationsFlatten;
      this.selectedCatalogues = this.classifications.map((item) => item.id);
    } else {
      this.serviceCopyProperties.catalogsToCopy.length = 0;
      this.selectedCatalogues = [];
    }
    this.allClassificationSelected = !this.allClassificationSelected;
  }

  public clearAllCatalogues(): void {
    this.serviceCopyProperties.catalogsToCopy.length = 0;
  }

  public selectedCatalogue(e) {
    if (this.allClassificationSelected === true) {
      this.allClassificationSelected = false;
      this.serviceCopyProperties.catalogsToCopy.length = 0;
    }
    this.serviceCopyProperties.catalogsToCopy.push(e.id);
  }

  public removedCatalogue(e) {
    this.serviceCopyProperties.catalogsToCopy = this.serviceCopyProperties.catalogsToCopy.splice(this.serviceCopyProperties.catalogsToCopy.indexOf(e.id), 1);
  }

  public srviceSelected() {
    if (this.serviceCopyProperties.serviceSelected) {
      this.serviceCopyProperties.determinantsSelected = true;
      this.serviceCopyProperties.activityConditionsSelected = true;
      this.serviceCopyProperties.applicantFormSelected = true;
      this.serviceCopyProperties.costsSelected = true;
      this.serviceCopyProperties.registrationLawsSelected = true;
      this.serviceCopyProperties.registrationsSelected = true;
      this.serviceCopyProperties.requirementsSelected = true;
      this.serviceCopyProperties.resultsSelected = true;
      this.serviceCopyProperties.rolesSelected = true;
      this.serviceCopyProperties.botsSelected = true;
      this.serviceCopyProperties.serviceLocationsSelected = true;
      this.serviceCopyProperties.serviceTutorialsSelected = true;
      this.serviceCopyProperties.serviceTranslationsSelected = true;
      this.serviceCopyProperties.sendFileFormSelected = true;
      this.serviceCopyProperties.guideFormSelected = true;
      this.serviceCopyProperties.paymentFormSelected = true;
      this.serviceCopyProperties.catalogsSelected = true;
      this.serviceCopyProperties.printDocumentsSelected = true;
    }
  }
  public getHeaderSizeClass(type) {
    if ( type === "title" ) {
      return "col-11";
    } else {
      return "col-1";
    }
  }
}
